module.exports = __webpack_public_path__ + "static/juiblex-8dde209c2e9da7cf5324da2d80daa6db.png";